(function(){
  var SEL = '.rv,.fade,.wipe,.mask';

  function reveal(el){ el.classList.add('in'); }

  function run(){
    var orphans = [];
    document.querySelectorAll(SEL).forEach(function(el){
      /* elements whose animation is driven by a .reveal ancestor are fine */
      if (el.closest('.reveal')) return;
      orphans.push(el);
    });

    if (orphans.length && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ reveal(e.target); io.unobserve(e.target); }
        });
      }, {threshold:.05, rootMargin:'0px 0px -4% 0px'});
      orphans.forEach(function(el){ io.observe(el); });
    } else {
      orphans.forEach(reveal);
    }

    /* failsafe: nothing stays hidden, whatever happens above */
    setTimeout(function(){
      document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
      document.querySelectorAll(SEL).forEach(reveal);
    }, 2600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
